import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '../../../ui_kit/accordion/Accordion';
import styles from './Faqs.module.sass';

function Faqs(props) {
  const { faqs = [] } = props;
  return (
    <div className={styles['faqs-wrapper']}>
      { faqs.map((faq) => (
        <Accordion
          headingClassName={styles['accordion-head']}
          heading={<div dangerouslySetInnerHTML={{ __html: faq.question_text }} />}
          content={<div dangerouslySetInnerHTML={{ __html: faq.answer_text }} />}
          key={faq.id}
          background="spring-wood"
          headingBackground="spring-wood"
        />
      ))}
    </div>
  );
}

Faqs.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.shape({})),
};

export default Faqs;
